import MediaQuery from 'src/DistributionPackages/Avaloq.NodeTypes/Resources/Private/JavaScript/Modules/MediaQuery.js'
import ProductStackModal from './ProductStackModal'
import { debounce } from 'src/DistributionPackages/Avaloq.NodeTypes/Resources/Private/JavaScript/Modules/Debounce.js'

export default class ProductStackTiles {
    static TILE_FOCUS_CLASS = 'product-stack__tile--focus'
    static TILE_DISABLED_CLASS = 'product-stack__tile--disabled'
    static COLLECTION_FOCUS_CLASS = 'product-stack__collection--focus'
    static COLLECTION_DISABLED_CLASS = 'product-stack__collection--disabled'

    constructor(productStack) {
        this.productStack = productStack
        this.tiles = this.productStack.querySelectorAll('.js-product-stack__tile')
        this.tileCollections = [...productStack.querySelectorAll('.js-product-stack__collection')]
        this.modal = new ProductStackModal(this.productStack)
        this.collectionOffsets = []
        this.tilesToPillOne = [0, 1, 2, 3, 4]
        this.tilesToPillTwo = [2, 3]
        this.tilesToPillThree = [1, 2]

        this.initCollectionOffsetsResizeListener()
        this.initFocusTileDebounce()
        this.tilesCollectionObserver()
        this.disableAllTiles()
        this.enableTiles(this.tilesToPillOne)
        this.tilesListener()
    }

    tilesListener() {
        this.tiles.forEach((tile, index) => {
            tile.addEventListener('click', () => {
                if (tile.classList.contains(ProductStackTiles.TILE_DISABLED_CLASS)) {
                    return
                }
                if (MediaQuery.UpMd.matches) {
                    window.scroll(0, this.collectionOffsets[index])
                } else {
                    this.modal.activateCollectionModal(index)
                }
            })
        })
    }

    tilesCollectionObserver() {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const index = this.tileCollections.indexOf(entry.target)
                    if (
                        entry.isIntersecting &&
                        !this.tiles[index].classList.contains(ProductStackTiles.TILE_FOCUS_CLASS)
                    ) {
                        this.unFocusAllTiles()
                        if (MediaQuery.UpMd.matches) {
                            this.focusTile(index)
                        }
                    }
                })
            },
            {
                rootMargin: '-45% 0px -45% 0px',
            }
        )
        this.tileCollections.forEach((collection) => {
            observer.observe(collection)
        })
    }

    disableAllTiles() {
        this.tiles.forEach((tile) => {
            tile.classList.add(ProductStackTiles.TILE_DISABLED_CLASS)
        })
        this.tileCollections.forEach((collection) => {
            collection.classList.add(ProductStackTiles.COLLECTION_DISABLED_CLASS)
        })
    }

    enableTiles(numbers = [0, 1, 2, 3, 4]) {
        numbers.forEach((number) => {
            this.tiles[number].classList.remove(ProductStackTiles.TILE_DISABLED_CLASS)
            this.tileCollections[number].classList.remove(ProductStackTiles.COLLECTION_DISABLED_CLASS)
        })
        this.focusTile(numbers[0])
        this.collectionOffsets = this.calculateCollectionOffsets()
    }

    unFocusAllTiles() {
        this.tiles.forEach((tile) => tile.classList.remove(ProductStackTiles.TILE_FOCUS_CLASS))
    }

    /**
     * This function initializes the function `focusTile()` with a debounce applied to it. Calling `focusTile()` in
     * quick succession debounces the focus so only the last call of the function is executed
     */
    initFocusTileDebounce() {
        this.focusTile = debounce((index) => {
            this.tiles[index].classList.add(ProductStackTiles.TILE_FOCUS_CLASS)
            this.tileCollections.forEach((collection) =>
                collection.classList.remove(ProductStackTiles.COLLECTION_FOCUS_CLASS)
            )
            this.tileCollections[index].classList.add(ProductStackTiles.COLLECTION_FOCUS_CLASS)
        }, 200)
    }

    calculateCollectionOffsets() {
        return Array.from(this.modal.tileCollections).map((tile) => {
            const bodyStyle = document.body.getBoundingClientRect()
            const elementStyle = tile.getBoundingClientRect()
            const headerHeight = 76

            return elementStyle.top - headerHeight / 2 - bodyStyle.top + (-window.innerHeight + elementStyle.height) / 2
        })
    }

    initCollectionOffsetsResizeListener() {
        window.addEventListener(
            'resize',
            debounce(() => {
                this.collectionOffsets = this.calculateCollectionOffsets()
            }, 1000)
        )
    }
}
